import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import { type ModalInitialState } from './types';

const initialState: ModalInitialState = {
  isModalOpen: false,
  modalType: null,
  modalData: {},
};

export const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openModal: (
      state,
      {
        payload: { modalType, modalData },
      }: PayloadAction<Omit<ModalInitialState, 'isModalOpen'>>,
    ) => {
      state.isModalOpen = true;
      state.modalType = modalType;
      state.modalData = modalData;
    },
    closeModal: (state) => {
      state.isModalOpen = false;
    },
  },
});

export const { reducer: modalReducer } = modalSlice;
